// import { formatDate as DateFormat } from '@/utils'
import dateFormat from '@/plugin/dateFormat/dateFormat'
export default function useWorkAppointTime () {
  const defaultTimeRang = {
    begin: dateFormat(new Date(new Date().setHours(10, 0, 0, 0)), 'yyyy/MM/dd hh:mm'),
    end: dateFormat(new Date(new Date().setHours(17, 0, 0, 0)), 'yyyy/MM/dd hh:mm')
  }
  const appointState = {
    appointDate: {
      begin: new Date(defaultTimeRang.begin),
      end: new Date(defaultTimeRang.end)
    },
    workDate: {
      begin: new Date(defaultTimeRang.begin),
      end: new Date(defaultTimeRang.end)
    },
    soltLeft: [],
    soltRight: []
  }
  function setAppointDate (props) {
    /* 判断接口预约时间是否有值 */
    /* 这里判断是否有值，是为了选择日期的时候不用再赋值 */
    appointState.appointDate = {
      begin: props?.appointTimeRang?.begin ? new Date(props.appointTimeRang.begin) : new Date(defaultTimeRang.begin),
      end: props?.appointTimeRang?.end ? new Date(props.appointTimeRang.end) : new Date(defaultTimeRang.end)
    }
    /* 判断接口工作时间是否有值 */
    appointState.workDate = {
      begin: props?.workDateTimeRang?.begin ? new Date(props.workDateTimeRang.begin) : new Date(defaultTimeRang.begin),
      end: props?.workDateTimeRang?.end ? new Date(props.workDateTimeRang.end) : new Date(defaultTimeRang.end)
    }
  }
  /** 获取预约判断时间 */
  function getAppointJudgeTime () {
    const date = new Date()
    return {
      nowDate: date,
      nowTimeStamp: date.getTime(),
      afterOneHourTime: date.getTime() + (1 * 60 * 60 * 1000),
      workBeginTime: appointState.workDate.begin.getTime(),
      appointEndTime: appointState.appointDate.end.getTime()
    }
  }
  /**
   * 创建Solt列表，返回二维数组，第一个数组为左边选项，第二个数组为右边选项
   * @param {*} selectDay '今天' | '明天' | '后天'
   * @return {Solt[][]} Solt[][]
   */
  function createSoltList (selectDay) {
    // 判断条件 最早时间拿工作最早时间 最晚时间拿预约最晚时间
    const { nowDate, nowTimeStamp, afterOneHourTime, workBeginTime, appointEndTime } = getAppointJudgeTime()
    appointState.soltLeft = createSoltDay(true)
    let start = appointState.appointDate.begin.getHours()
    const end = appointState.appointDate.end.getHours()
    if (selectDay === '今天' || !selectDay) {
      if (nowTimeStamp < workBeginTime) {
        // 当前时间早于工作最早时间  日期显示今明后 小时段不显示一小时内
        createSoltHour(start, end, false)
      } else if (afterOneHourTime > appointEndTime) {
        // 当前时间一小时后晚于最晚预约时间  日期显示明后 小时段不显示一小时内
        createSoltHour(start, end, false)
      } else if (nowTimeStamp >= workBeginTime && afterOneHourTime <= appointEndTime) {
        // 当前时间大于最早工作时间 且 当前时间一小时后 早于最晚预约时间  日期显示今明后 小时段显示一小时内
        start = nowDate.getHours()
        createSoltHour(start, end, true)
      }
    } else {
      createSoltHour(start, end, false)
    }
    return [appointState.soltLeft, appointState.soltRight]
  }
  function createSoltHour (start, end, flage) {
    /*
     * 可预约时间段超过半小时，不足一小时按新的一项显示出来，例如：17:00-17:40
     * 因为每一项是从上一项的时间累加一小时得出的，即开始时间为10:20，那么第一项是10:20-11:20,以此类推
     * 循环算法中只判断了i < endHour,没有判断展示最后时间，所以拿最后时间的分(整点按60分取值)-开始时间的分，
     * 超过半小时就要增加多一项显示剩余的时间
     */
    const beginMinutes = +appointState.appointDate.begin.getMinutes()
    const endMinutes = +appointState.appointDate.end.getMinutes() || 60
    if (Math.abs(endMinutes - beginMinutes) > 30) {
      end = end + 1
    }
    appointState.soltRight = []
    if (flage) {
      appointState.soltRight.push({ text: '1小时内上门', value: '1小时内上门' })
    }
    while (start < end) {
      const solt = getHourRang(start, flage)
      if (solt) {
        const value = `${solt.split('-')[1]}:00`.trim()
        appointState.soltRight.push({ text: solt, value: `${value}` })
      }
      start++
    }
    return appointState.soltRight
  }
  // 生成今明后的年月日 isMore未来一个月的时间
  function createSoltDay (isMore) {
    const { nowDate, nowTimeStamp, afterOneHourTime, workBeginTime, appointEndTime } = getAppointJudgeTime()
    const today = dateFormat(nowDate, 'yyyy/MM/dd')
    const tomorrow = dateFormat(new Date(new Date().setDate(nowDate.getDate() + 1)), 'yyyy/MM/dd')
    const dayAfterTomorrow = dateFormat(new Date(new Date().setDate(nowDate.getDate() + 2)), 'yyyy/MM/dd')
    const arr = [
      { text: '今天', value: today },
      { text: '明天', value: tomorrow },
      { text: '后天', value: dayAfterTomorrow }
    ]
    const arrMore = createSoltDayMore(nowDate)
    const resultArr = isMore ? [...arr, ...arrMore] : arr
    if (nowTimeStamp < workBeginTime) {
      // 当前时间早于工作最早时间  日期显示今明后 小时段不显示一小时内
      return resultArr
    } else if (afterOneHourTime > appointEndTime) {
      // 当前时间一小时后晚于最晚预约时间  日期显示明后 小时段不显示一小时内
      return resultArr.splice(1)
    } else if (nowTimeStamp >= workBeginTime && afterOneHourTime <= appointEndTime) {
      // 当前时间大于最早工作时间 且 当前时间一小时后 早于最晚预约时间  日期显示今明后 小时段显示一小时内
      return resultArr
    } else {
      return resultArr
    }
  }
  /***
   * 设置第三天到x天后的时间()
   * nowDate:2023/08/23 今天的日期对象
   * dayNum: 30
   */
  function createSoltDayMore (nowDate, dayNum = 30) {
    let arrMore = []
    for (let index = 3; index <= dayNum; index++) {
      let dayValue = dateFormat(new Date(new Date().setDate(nowDate.getDate() + index)), 'yyyy/MM/dd')
      let monthText = (new Date(dayValue).getMonth() + 1)
      let dayText = (new Date(dayValue).getDate())
      let textName = `${monthText}月${dayText}日`
      let obj = { text: textName, value: dayValue }
      arrMore.push(obj)
    }
    return arrMore
  }
  function getHourRang (i, flage) {
    const judgeData = judgeHourAdapter(i)
    const leftH = String(i).padStart(2, '0')
    if (judgeData.remainderHour <= 1.5 && judgeData.remainderHour > 0.5) {
      // 最后一个solt
      if (flage) {
        if (judgeData.nowHM < judgeData.soltHM) {
          return `${leftH}:${judgeData.beginMinutes} - ${String(judgeData.endHour).padStart(2, '0')}:${judgeData.endMinutes}`
        }
      } else {
        return `${leftH}:${judgeData.beginMinutes} - ${String(judgeData.endHour).padStart(2, '0')}:${judgeData.endMinutes}`
      }
    } else if (judgeData.remainderHour > 1.5 || judgeData.remainderHour === 1) {
      if (flage) {
        // 现在的时间大于工作开始时间，小于预约开始时间，不返回选项，因为显示了一小时内
        if (judgeData.nowHM < judgeData.soltHM && i > judgeData.beginHour) {
          // 现在的时间小于现在slot的时间，就显示现在小时的solt
          return `${leftH}:${judgeData.beginMinutes} - ${String(judgeData.tempHour).padStart(2, '0')}:${judgeData.beginMinutes}`
        }
      } else {
        // 生成明天和后天的时间solt
        return `${leftH}:${judgeData.beginMinutes} - ${String(judgeData.tempHour).padStart(2, '0')}:${judgeData.beginMinutes}`
      }
    }
  }
  // 用于判断生成小时的数据的适配器
  function judgeHourAdapter (value) {
    const nowDate = new Date()
    const tempHour = Number(value) + 1
    const beginHour = appointState.appointDate.begin.getHours()
    const endHour = appointState.appointDate.end.getHours()
    let beginMinutes = appointState.appointDate.begin.getMinutes() + ''
    beginMinutes = String(beginMinutes).padStart(2, '0')
    let endMinutes = appointState.appointDate.end.getMinutes() + ''
    endMinutes = String(endMinutes).padStart(2, '0')

    // 时分换算成可计算格式
    const nowHM = Number(nowDate.getHours()) + Number(nowDate.getMinutes()) / 60 // 现在时间的时分
    const endHM = Number(endHour) + Number(endMinutes) / 60 // 最晚预约时间的时分
    const soltHM = Number(value) + Number(beginMinutes) / 60 // 现在时间的左边solt
    const remainderHour = endHM - soltHM

    return {
      tempHour,
      beginHour,
      nowHM,
      endHM,
      soltHM,
      remainderHour,
      beginMinutes,
      endHour,
      endMinutes
    }
  }

  // 当前时间比对工作结束时间
  // 当前时间大于工作结束时间，展示明天第一个营业时间
  // 当前时间超过24小时(小于明天的工作开始时间)，展示今天第一个营业时间
  function getFirstWorkDate () {
    const { nowTimeStamp, workBeginTime, appointEndTime } = getAppointJudgeTime()
    if (nowTimeStamp > appointEndTime || nowTimeStamp < workBeginTime) {
      const listArr = createSoltList('')
      const selectDay = listArr[0][0]
      const selectHour = listArr[1][0]
      const firstDate = {
        text: `${selectDay.text} ${selectHour.text}`,
        value: `${selectDay.value} ${selectHour.value}`
      }
      return firstDate
    }
    return false
  }

  return {
    setAppointDate,
    getAppointJudgeTime,
    createSoltList,
    getFirstWorkDate
  }
}
